import { ProjectFinancial } from './../project/ProjectFinancial.model';
import { Owner } from './Owner.model';
import { Parcel } from './Parcel.model';
import { Project } from './Project.model';
import { Cost } from './Cost.model';
import { Company } from './Company.model';
import { CompanyGroup } from './CompanyGroup.model';
import { Contact } from "./Contact.model";
import * as _ from 'lodash';

export class BillingLetter {
    _id: string;
    name: string = '';
    closed: boolean = false;
    company: Company = null;
    owner: Owner = null;
    created: Date = new Date();
    changed: Date = new Date();
    projects: ProjectFinancial[] = new Array<ProjectFinancial>();
    products: any[];
    refunds: any[];
    cost: Cost = new Cost();
    parcels: Parcel[] = new Array<Parcel>();
    contacts: Contact[] = new Array<Contact>();
    active: boolean = true;
    parcelsNumber: number = 0;
    companyGroup: CompanyGroup = null;
    supportCenters: any[];
    excellenceCenters: any[];

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    public populateFromServer(r: any) {
        if (r._id)
            this._id = r._id;

        if (r.name)
            this.name = r.name;

        if (r.closed)
            this.closed = r.closed;

        if (r.company)
            this.company = r.company;

        if (r.companyGroup)
            this.companyGroup = r.companyGroup;

        if (r.owner) {
            this.owner = new Owner();
            this.owner.populate(r.owner);
        }

        if (r.created)
            this.created = r.created;

        if (r.changed)
            this.changed = r.changed;

        if (r.projects)
            if (r.projects)
                for (let p of r.projects) {
                    let project = new ProjectFinancial();
                    project.loadFromServer(p);
                    this.projects.push(project);
                }

        if (r.products)
            this.products = r.products;

        if(r.excellenceCenters)
            this.excellenceCenters = r.excellenceCenters;

        if(r.supportCenters)
            this.supportCenters = r.supportCenters

        if (r.refunds)
            this.refunds = r.refunds;

        if (r.cost)
            this.cost.populateFromServer(r.cost);

        if (r.parcels)
            for (let p of r.parcels) {
                let parcel = new Parcel(p);
                this.parcels.push(parcel);
                this.parcels = _.sortBy(this.parcels, ["issueDate", "created", "competence"]);
                //this.parcels.sort(function(a, b){ return ((new Date(a.issueDate).getTime() - new Date(b.issueDate).getTime()) && (a.competence - b.competence))});
            }

        if (r.contacts)
            for (let c of r.contacts) {
                let contact = new Contact();
                contact.populateFromServer(c);
                this.contacts.push(contact);
            }

        if (r.active)
            this.active = r.active;

        if (r.parcelsNumber)
            this.parcelsNumber = r.parcelsNumber;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/BillingLetter.model.ts